import React from 'react'
import PropTypes from 'prop-types'
import { colors } from '../../utils/constants'

const CommentaireIcon = ({ height, width, color }) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 24 24"
			style={{
				msTransform: "rotate(360deg)",
				WebkitTransform: "rotate(360deg)",
				verticalAlign: "-.125em",
			}}
			transform="rotate(360)"
		>
			<path
				d="M9 22a1 1 0 01-1-1v-3H4a2 2 0 01-2-2V4a2 2 0 012-2h16a2 2 0 012 2v12a2 2 0 01-2 2h-6.1l-3.7 3.71c-.2.19-.45.29-.7.29H9m4-12V6h-2v4h2m0 4v-2h-2v2h2z"
				fill={color}
			/>
			<path fill="rgba(0, 0, 0, 0)" d="M0 0h24v24H0z" />
		</svg>
	)
}

CommentaireIcon.propTypes = {
	height: PropTypes.string,
	width: PropTypes.string,
	color: PropTypes.string
}

CommentaireIcon.defaultProps = {
	height: '1.5rem',
	width: '1.5rem',
	color: colors.icon
}

export default CommentaireIcon
